<h2 mat-dialog-title>
  {{ 'INBOX.CONVERSATION_SUMMARY' | translate }}
</h2>
<mat-dialog-content>
  {{ data.summary }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'INBOX.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
